module.exports = __webpack_public_path__ + "img/logo.c61777ee.png";